<section class="md-search-tag broker" :class="{
            simple: simple,
            expand: expand,
            'in-more': inMore
        }" v-show="hasTag || (isMobileSize && !simple)">
    <div class="header" @click="toggleExpand">
        {{ $t('md-search-bar.filter', { count: tagCount })
        }}<span v-if="tagCount > 0" class="iconfont icon-arrow-down"></span>
    </div>
    <div v-if="inMore && !isMobileSize && !outSideSuggestion" class="inmore_header">
        {{ $t('md-search-bar.filterApplied', { count: tagCount }) }}
    </div>
    <div class="search-filter" ref="tags">
        <label class="more-count" v-if="hideCount > 0">
            <span class="count">{{ hideCount }}</span>
            {{ simple ? '+' : $t('md-search-bar.more') }}
        </label>
        <template v-for="(item, index) in filteredTagList">
            <label v-if="index >= hideCount" :class="
                        'data-tag ' +
                        (index === 0 ? 'first' : '') +
                        (index === tagCount - 1 && hideCount ? ' last' : '')
                    " :key="index" >
                {{ item.label }}
                <span class="icon-wrap">
                    <i class="iconfont icon-close" @click.stop="removeTag(item)"></i>
                </span>
            </label>
        </template>
        <!-- <label
                @click="removeAll()"
                class="remove-all iconfont icon-close"
                v-show="!collapse && !hideRemoveAll"
            ></label> -->
    </div>
</section>